//登录

import { deleteRequest, downPostRequest, getRequest, postRequest, putRequest } from '@/config/request';
import { SYS_BASE_URL } from "@/constant/Const";

export const login = (data) => {
    return postRequest(SYS_BASE_URL + "/api/login/login", data);
}

export const logout = (data) => {
    return getRequest(SYS_BASE_URL + "/api/login/loginOut", data);
}

//获取路由
export const getRouteList = (data) => {
    return getRequest(SYS_BASE_URL + "/api/menu/tree", data);
}
//获取登录图形验证码
export const getloginimage = (data) => {
    return getRequest(SYS_BASE_URL + "/api/login/captcha", data, 'blob');
    // return getRequest(SYS_BASE_URL + "/api/login/image", data);
}
// 获取登录二维码 /upm-app/api/login/pc
export const getLoginQrCode = (data) => {
    return getRequest(SYS_BASE_URL + "/api/login/pc", data);
}
// 获取登录二维码 /upm-app/api/login/pc/zhuce
export const getLoginQrCodeZhuce = (data) => {
    return getRequest(SYS_BASE_URL + "/api/login/pc/zhuce", data);
}
// 获取登录二维码 /upm-app/api/login/pc/mima
export const getLoginQrCodeMima = (data) => {
    return getRequest(SYS_BASE_URL + "/api/login/pc/mima", data);
}
// 微信扫码 通过 code 获取openId  /upm-app/api/login/openId
export const getLoginOpenId = (data) => {
    return getRequest(SYS_BASE_URL + "/api/login/openId", data);
}
// 微信扫码 通过 code 获取 access_token   /upm-app/api/login/callbackQr
export const getLoginCallbackQr = (data) => {
    return getRequest(SYS_BASE_URL + "/api/login/callbackQr", data);
}
//  微信PC登陆 /api/user/wxLogin
export const userWxLogin = (data) => {
    return postRequest(SYS_BASE_URL + "/api/user/wxLogin", data);
}
//  微信PC注册 /api/user/wechatBindApp
export const userWechatBindApp = (data) => {
    return postRequest(SYS_BASE_URL + "/api/user/wechatBindApp", data);
}
//  微信PC找回密码  /api/user/wxForgetPassword
export const userWxForgetPassword= (data) => {
    return postRequest(SYS_BASE_URL + "/api/user/wxForgetPassword", data);
}